import AssetImage from '@/components/AssetImage';
import MathUtils from '@/utils/MathUtils';
import StringUtils from '@/utils/StringUtils';
import StyleUtils from '@/utils/StyleUtils';
import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface Asset {
  symbol: string;
  qty?: number;
  change?: number;
  changePercent?: number;
  latestPrice?: number;
  image?: string;
  name: string;
}

interface IAssetListItemProps {
  asset: Asset;
  onClick: (symbol: string) => void;
  className?: string;
  as?: 'list-item' | 'button';
}

function AssetListItem({ asset, onClick, className, as }: IAssetListItemProps) {
  const content = 
  <button
    onClick={() => onClick(asset.symbol)}
    className={twMerge(
      clsx(
        'flex w-full justify-between items-center p-4 text-left hover:bg-darkglass',
        className
      )
    )}
    type="button"
  >
    <div className="flex space-x-4 w-full px-4">
      <AssetImage alt={asset?.symbol as string} src={asset?.image || ''}/>
      <div className="flex flex-row justify-between w-full">
        <div className="w-3/4">
          <h4 className='line-clamp-1'>{asset.name}</h4>
          <h6 className="text-secondary">
            {asset.symbol}
            {asset?.qty
              ? ` · ${
                  Number(asset.qty).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 3,
                  }) || 0
                } shares`
              : ''}
          </h6>
        </div>
        <div className="text-right">
          <h4 className={clsx(StyleUtils.getChangeStyle(asset?.changePercent || 0))}>
            {MathUtils.round(asset?.changePercent || 0, 0.01)}%
          </h4>
          <h6 className="text-secondary">{StringUtils.USD(asset?.latestPrice || 0)}</h6>
        </div>
      </div>
    </div>
  </button>

  if (as === 'list-item') {
    return <li>{content}</li>;
  }
  return (
    content
  );
}

export default AssetListItem;
